export default {
  inserted: (el, { value }) => setPageTitle(value),
  update: (el, { value, oldValue }) => {
    if (value !== oldValue) {
      setPageTitle(value);
    }
  },
};

export function setPageTitle(title) {
  document.title = title;
}
